import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { Link } from 'react-router-dom';

import { media } from '../../../styles/media-templates';

export const HeaderContainer = styled.div`
  width: calc(100% - ${({ theme }) => theme.sz.sidebarWidth});
  min-height: 203px;
  position: fixed;
  z-index: 99;
  background-color: ${({ theme }) => theme.background};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  ${media.phone`
    width: 100%;
  `}
`;

export const PlusSymbol = styled.span`
  font-size: 1.667rem;
  padding-right: 10px;
`;

export const TableHeader = styled.div<{ $isHidden: boolean }>`
  padding: 0 ${({ theme }) => theme.sz.pageSidePadding};
  display: flex;
  flex-wrap: nowrap;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  box-sizing: border-box;
  opacity: ${({ $isHidden }) => ($isHidden ? 0 : 1)};
  transition: opacity 500ms;
  ${media.desktop`
    padding: 0 ${({ theme }) => (theme as DefaultTheme).sz.pageSidePaddingS};
  `}
`;

export const AddObjectiveLnk = styled(({ $smallHeader, ...rest }) => React.createElement(Link, rest))<{
  $smallHeader: boolean;
}>`
  display: block;
  opacity: ${({ $smallHeader }) => ($smallHeader ? 0 : 1)};
`;
